import { Box, Typography } from "@mui/material";
import { RoutingURLs } from "../../../config/RoutingURLs";
import { paymentLandingProps } from "./PaymentLandingComponent";
import { useNavigate, useLocation } from "react-router-dom";
import EnvConfig from "../../../config/env.config.json";
import _ from "lodash";
import { ButtonCust } from "../../widgets";
import { useEffect, useRef } from "react";
import ENVConfig from "../../../config/env.config.json";
import { gtmTagManager } from "../../../utils/commonFunctions/GtmTagManager";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import styles from "./S2_PaymentLanding.module.scss";
import {
  deleteCartItems,
  getCartItems,
} from "../../../features/shopWare/shopWareSlice";
const PaymentLanding = (props: paymentLandingProps) => {
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  const { content, loader } = props;
  const {
    tick_icon,
    heading,
    description,
    btn_txt,
    btn_txt2,
    fail_icon,
    fail_heading,
    fail_desc,
    correct_cc_desc,
    fail_btn_text,
    help_txt,
  } = content;
  const navigate = useNavigate();
  const location: any = useLocation();
  const dispatch = useAppDispatch();
  const formRef = useRef<HTMLFormElement>(null);
  let currentdetails: any = localStorage.getItem("customerDetail");
  currentdetails = currentdetails ? JSON.parse(currentdetails) : null;
  const handleContinueToDashBoard = () => {
    if (location?.state?.redirectionURL) {
      navigate(location?.state?.redirectionURL);
    } else {
      navigate(RoutingURLs.myAccount);
    }
    gtmTagManager({
      event: globalVal?.gtmEvents?.continueToDashboard,
      click_section: "checkout",
    });
  };
  const retryPayment = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  useEffect(() => {
    if (EnvConfig?.IS_SHOPWARE_ENABLED) {
      deleteCart();
    }
  }, []);
  const deleteCart = () => {
    let lineItemsInCart: any = localStorage.getItem("lineItems");
    lineItemsInCart = JSON.parse(lineItemsInCart);
    let planDetails: any = localStorage.getItem("reachSelectedPlanDetail");
    planDetails = JSON.parse(planDetails);
    let deletionId: any = lineItemsInCart?.find((item: any) => {
      return item?.payload?.planName === planDetails?.plan?.displayName;
    });
    if (deletionId) {
      dispatch(deleteCartItems(deletionId?.id)).then((res: any) => {
        if (res) {
          dispatch(getCartItems());
        }
      });
    }
  };

  return (
    <>
      <Box
        sx={{
          pb: "30px",
        }}
      >
        <Box
          sx={{
            margin: "100px auto 0px",
            background: "var(--white)",
            textAlign: "center",
            width: { xs: "75%", sm: "90%", md: "60%", lg: "35%" },
            padding: { xs: "20px", sm: "30px" },
            mt: "100px",
            borderRadius: "10px",
            // boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.15)",
          }}
        >
          {location?.state?.emailId || location?.state?.success ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component={"img"}
                  alt={tick_icon?.data?.attributes?.alternativeText}
                  src={content?.tick_icon?.data?.attributes?.url}
                  width={"188px"}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "10px 0px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "20px", sm: "24px" },
                    fontFamily: "var(--font_family_Bold)",
                    lineHeight: "30px",
                    marginLeft: "5px",
                    fontWeight: 700,
                    color: "var(--title-color_1)",
                  }}
                >
                  {heading}
                </Typography>
              </Box>
              <Box sx={{ mt: "18px", mb: "10px" }}>
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    fontFamily: "var(--font_family_Regular)",
                    lineHeight: "21px",
                    width: { xs: "100%", sm: "100%", md: "85%" },
                    color: "var(--text_color_12)",
                    mx: "auto",
                  }}
                >
                  {location?.state?.description
                    ? location?.state?.description
                    : description}
                </Typography>
              </Box>
              <Box>
                <ButtonCust
                  sx={{
                    fontSize: "16px",
                    lineHeight: "28px",
                    fontFamily: "var(--font_family_Medium)",
                    mt: "10px",
                  }}
                  variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                  onClick={handleContinueToDashBoard}
                >
                  {location?.state?.redirectionURL ? btn_txt2 : btn_txt}
                </ButtonCust>

                <Box sx={{ display: help_txt ? "block" : "none" }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", sm: "14px" },
                      fontFamily: "var(--font_family_Bold)",
                      lineHeight: "21px",
                      width: { xs: "100%", sm: "100%", md: "95%" },
                      margin: "30px auto 0 auto",
                    }}
                  >
                    {help_txt}
                  </Typography>
                  <div
                    className={styles.helplink}
                    id="ZN_bOXrJMlkEamEJjE"
                  ></div>
                </Box>
              </Box>
            </>
          ) : (
            <>
              <form
                ref={formRef}
                method="post"
                name="paymentForm"
                id="paymentForm"
                action={ENVConfig.CHECKOUT_PAYMENT}
              >
                <input
                  type="hidden"
                  name="emailId"
                  value={
                    (currentdetails && currentdetails?.emailId) ||
                    currentdetails?.username ||
                    currentdetails?.email_address ||
                    currentdetails?.email
                  }
                />
                <input
                  type="hidden"
                  name="redirectUrl"
                  value={`${window.location.origin}/loader`}
                />
                {ENVConfig?.IS_AUTOPAY_ENABLED && ENVConfig?.TENANT_ID ? (
                  <>
                    <input
                      type="hidden"
                      name="tenant"
                      value={ENVConfig?.TENANT_ID}
                    />
                    <input type="hidden" name="saveCard" value={String(true)} />
                    <input type="hidden" name="autoPay" value={String(true)} />
                    <input
                      type="hidden"
                      name="defaultCard"
                      value={String(true)}
                    />
                  </>
                ) : null}
              </form>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  component={"img"}
                  alt={fail_icon?.data?.attributes?.alternativeText}
                  src={fail_icon?.data?.attributes?.url}
                />
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontFamily: "var(--font_family_Bold)",
                    lineHeight: "30px",
                    marginLeft: "5px",
                    fontWeight: 700,
                    color: "var(--text_color_12)",
                  }}
                >
                  {fail_heading}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "var(--font_family_Medium)",
                    fontWeight: 400,
                    lineHeight: "21px",
                    mt: "38.6px",
                  }}
                >
                  {fail_desc}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "var(--font_family_Medium)",
                    fontWeight: 400,
                    lineHeight: "21px",
                    mt: "30px",
                  }}
                >
                  {correct_cc_desc}
                </Typography>
              </Box>
              <Box>
                <ButtonCust
                  sx={{
                    fontSize: "16px",
                    lineHeight: "28px",
                    fontFamily: "var(--font_family_Medium)",
                    mt: "35px",
                    width: "100%",
                  }}
                  variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                  onClick={retryPayment}
                >
                  {fail_btn_text}
                </ButtonCust>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default PaymentLanding;
